<template>
    <label :for="isFor" class="block text-xs font-bold text-cal-525252 p-0"><slot></slot>:</label>
</template>
<script>
export default {
    name: 'FormLabel',
    props: {
        isFor: String,
    }
}
</script>
